import { measuredUsingConfigFor as wrap } from 'Components/Worksheets/Core/Helpers/configHelpers';

//defines which balance is used for which masses.
//tends to be constant across all test types.
const getMeasuredUsingConfig = (prefix: string) => {
  const dryBalance = wrap(`${prefix}.Equipment.DryMassBalance`);
  const asReceivedBalance = wrap(`${prefix}.Equipment.Balance`);
  return {
    [`${prefix}.DryingTray.ContainerMass`]: asReceivedBalance,
    [`${prefix}.DryingTray.WetSoilAndContainerMass`]: asReceivedBalance,
    [`${prefix}.DryingTray.DryMassReadings.DrySoilAndContainerMass`]: dryBalance,

    [`${prefix}.DryingTrays.ContainerMass`]: asReceivedBalance,
    [`${prefix}.DryingTrays.WetSoilAndContainerMass`]: asReceivedBalance,
    [`${prefix}.DryingTrays.DryMassReadings.DrySoilAndContainerMass`]: dryBalance,
  };
};

export default getMeasuredUsingConfig;
